module.exports = __webpack_public_path__ + "img/yakitori-pic.a5736453.png";